import {combineReducers} from 'redux'
import colors from './colors'
import selectedPath from './selectedPath'
import selectedTile from './selectedTile'
import currentColors from './currentColors'
import selectedSample from './selectedSample'
import selectedColor from './selectedColor'
import tiles from './tiles'


const appReducer = combineReducers({
	tiles,
	colors,
	selectedPath,
	selectedTile,
	selectedSample,
	selectedColor,
	currentColors
});

export default appReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js